import type { CMSApiBase, CMSArrayBase, CMSImageBase } from './base';

export interface Method extends CMSArrayBase {
  name: string;
  type: string;
  fee: string;
  processingTime: string;
  limitsPerTransaction: string; // HTML
  image: CMSImageBase;
  imageGrayscale: CMSImageBase;
  registrationForm: boolean;
  lobbySlider: boolean;
  paymentMethodsPage: boolean;
}

export enum MethodGroupType {
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
}

export interface MethodGroup extends CMSArrayBase {
  title: string;
  type: MethodGroupType;
  methods: Method[];
}

export interface PaymentMethodsApi extends CMSApiBase {
  title: string;
  titleH1: string;
  text: string;
  methodsGroups: MethodGroup[];
}
